import { ChangeDetectorRef, Component } from '@angular/core';
import { WorkingTimeSchemaService } from './working-time-schema.service';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { DateUtil } from 'app/core/utils/DateUtil';
import { ShowToastService } from 'app/shared/services/showToast.service';

const EDITED_NON_WORKING_HOURS_USER = 'bmc-edited-non-working-hours-user';
const EDITED_WORKING_HOURS_USER = 'bmc-edited-working-hours-user';

const NON_WORKING_DAY_CLASS = 'bmc-non-working-day';
const EDITED_NON_HOURS_CLASS_COMPANY = 'bmc-edited-non-hours-company';
const EDITED_HOURS_CLASS_COMPANY = 'bmc-edited-hours-company';

@Component({
    selector: 'working-time-schema',
    templateUrl: 'working-time-schema.component.html',
    styleUrls: ['working-time-schema.component.scss']
})

export class WorkingTimeSchemaComponent {
  public datesCustomUserCalendarView = [];
  public datesCustomUserTable = []; 

  public currentCalendarSelected;
  public idCurrentCalendarSelected = 0;

  public selectedTab: number = 0;

  public someDateIsAlreadyTaken = false;
  public selectedUser: ISpecificUser;

  public weekDaysSchedule: {[key: string]: Array<IBaseCalendarTime>} = {};

  public bsConfig = {
    showWeekNumbers: false
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private _workingTimeSchemaService: WorkingTimeSchemaService,
    private _toastService: BzgToastService,
    private _i18nService: I18nService,
    private _modalService: BzgModalService,
    private _showToastService: ShowToastService) {
  }

  selectedCalendar(currentCalendarSelected) {
    this.currentCalendarSelected = currentCalendarSelected;
    this.idCurrentCalendarSelected = currentCalendarSelected.idWorkingTimeSchema;
    this.cdr.detectChanges(); // This is necessary to avoid  error console
  }

  getInfoUserSelected(userSelected) {
    if (userSelected && userSelected.idUser) {
      this.selectedUser = userSelected;
      this._workingTimeSchemaService.getBaseCalendar(this.selectedUser.idUser).subscribe(calendar => {
        this.currentCalendarSelected = calendar;
        this.idCurrentCalendarSelected = calendar.idWorkingTimeSchema;
      });

      this.datesCustomUserCalendarView = [];
      this._workingTimeSchemaService.getWorkingTimeSchema(this.selectedUser.idUser).subscribe(calendar => {
        if (calendar) {
          let idEditCounter = 1;
          this.datesCustomUserTable = calendar.map(item => {
            return { ...item, idEdit: idEditCounter++ };
          });
          this.datesCustomUserCalendarView = this.refreshCalendarView(this.datesCustomUserTable);
        }
      });
    } else
      this.cleanAll();
    
  }

  cleanAll() {
    this.selectedUser = null;
    this.currentCalendarSelected = null;
    this.idCurrentCalendarSelected = 0;
    this.datesCustomUserCalendarView = [];
    this.datesCustomUserTable = [];
  }

  newDateCustomUser(newDateSchemaUser) {
    let datesCustomUserTable = [...this.datesCustomUserTable];
    let datesCustomUserCalendarView = [...this.datesCustomUserCalendarView];

    const maxIdEdit = datesCustomUserTable.reduce((max, item) => item.idEdit > max ? item.idEdit : max, 0);
    
    let fromDate = newDateSchemaUser.currentDateType === 'exact' ? newDateSchemaUser.onDate: newDateSchemaUser.startDate;
    let toDate = newDateSchemaUser.currentDateType === 'exact' ? newDateSchemaUser.onDate: newDateSchemaUser.finishDate;

    const newWorkingTimeSchema = {
      idWorkingTimeData: null,
      idUser: this.selectedUser.idUser,
      idEdit: maxIdEdit + 1,
      weekDay: null,
      isWorking: newDateSchemaUser.fromTime1 ? true : false,
      fromDate,
      toDate
    };

    for (let i = 1; i <= 5; i++) {
      if (newDateSchemaUser[`fromTime${i}`] && newDateSchemaUser[`toTime${i}`]) {
        newWorkingTimeSchema[`fromTime${i}`] = DateUtil.alreadyUTCRemoveOffsetString(newDateSchemaUser[`fromTime${i}`]);
        newWorkingTimeSchema[`toTime${i}`] = DateUtil.alreadyUTCRemoveOffsetString(newDateSchemaUser[`toTime${i}`]);
      } else {
        newWorkingTimeSchema[`fromTime${i}`] = null;
        newWorkingTimeSchema[`toTime${i}`] = null;
      }
    }

    this.isDateAlreadyInArray(newWorkingTimeSchema);
    if (!this.someDateIsAlreadyTaken) {
      const newClasses = this.setCustomClassesUserDates(newWorkingTimeSchema);
      datesCustomUserCalendarView = [...datesCustomUserCalendarView, ...newClasses];
      datesCustomUserTable.push(newWorkingTimeSchema);

      this.datesCustomUserTable = [];
      this.datesCustomUserTable = datesCustomUserTable;

      this.datesCustomUserCalendarView = [];
      this.datesCustomUserCalendarView = datesCustomUserCalendarView;
    }
  }

  editDateCustomUser(editedDateSchemaUser) {
    this.isDateAlreadyInArray(editedDateSchemaUser);
    if (!this.someDateIsAlreadyTaken) {
      let datesCustomUserTable = [...this.datesCustomUserTable];
      this.datesCustomUserTable = [];
      let dateToEdit = datesCustomUserTable.find(date => date.idEdit === editedDateSchemaUser.idEdit);
    
      dateToEdit.fromDate = editedDateSchemaUser.fromDate;
      dateToEdit.toDate = editedDateSchemaUser.toDate;
      this.datesCustomUserTable = [];

      for (let i = 1; i <= 5; i++) {
        dateToEdit[`fromTime${i}`] = editedDateSchemaUser[`fromTime${i}`] ? DateUtil.alreadyUTCRemoveOffsetString(editedDateSchemaUser[`fromTime${i}`]) : null;
        dateToEdit[`toTime${i}`] = editedDateSchemaUser[`toTime${i}`] ? DateUtil.alreadyUTCRemoveOffsetString(editedDateSchemaUser[`toTime${i}`]) : null;
      }

      this.datesCustomUserCalendarView = [];
      this.datesCustomUserTable = datesCustomUserTable;
      this.datesCustomUserCalendarView = this.refreshCalendarView(this.datesCustomUserTable);
    } else {
      const datesCustomUserTable = [...this.datesCustomUserTable];
      this.datesCustomUserTable = [];
      this.datesCustomUserTable = datesCustomUserTable;
    }
  }

  deleteDateCustomUser(deletedDateSchemaUser) {
    let datesCustomUserTable = [...this.datesCustomUserTable];
    this.datesCustomUserTable = [];
    this.datesCustomUserTable = datesCustomUserTable.filter(date => date.idEdit !== deletedDateSchemaUser.idEdit);
    this.datesCustomUserCalendarView = [];
    this.datesCustomUserCalendarView = this.refreshCalendarView(this.datesCustomUserTable);
  }

  refreshCalendarView(calendar) {
    let datesCustomUserCalendarView = [];
    calendar.forEach(day => {
      const newClasses = this.setCustomClassesUserDates(day);
      datesCustomUserCalendarView.push(...newClasses);
    });
    return datesCustomUserCalendarView;
  }

  setCustomClassesUserDates(newWorkingTimeSchema) {
    let dateCustomClassesUser = [];
    const startDate = newWorkingTimeSchema.fromDate;
    const finishDate = newWorkingTimeSchema.toDate;
    const daysBetween = this.getDaysBetween(startDate, finishDate);

    for (let i = 0; i < daysBetween; i++) {
      const dateToAdd = new Date(newWorkingTimeSchema.fromDate);
      dateToAdd.setDate(dateToAdd.getDate() + i);
      if (newWorkingTimeSchema.isWorking) 
        dateCustomClassesUser.push(
        { 
          classes: [EDITED_WORKING_HOURS_USER, EDITED_WORKING_HOURS_USER + "__" + DateUtil.converDateToStringNoAddOffset(dateToAdd)],
          date: dateToAdd, 
          dateToSearch: DateUtil.converDateToStringNoAddOffset(dateToAdd),
          isCompany: false,
          workingTime: newWorkingTimeSchema,
        });
      else
        dateCustomClassesUser.push(
        {
          classes: [EDITED_NON_WORKING_HOURS_USER, EDITED_NON_WORKING_HOURS_USER + "__" + DateUtil.converDateToStringNoAddOffset(dateToAdd)],
          date: dateToAdd, 
          dateToSearch: DateUtil.converDateToStringNoAddOffset(dateToAdd),
          isCompany: false,
          workingTime: newWorkingTimeSchema,
        });
    }
    return dateCustomClassesUser;
  }

  isDateAlreadyInArray(newWorkingTimeSchema) {
    this.someDateIsAlreadyTaken = false;
    const startDate = newWorkingTimeSchema.fromDate;
    const finishDate = newWorkingTimeSchema.toDate;
    const daysBetween = this.getDaysBetween(startDate, finishDate);
    for (let i = 0; i < daysBetween; i++) {
      const dateToAdd = new Date(newWorkingTimeSchema.fromDate);
      dateToAdd.setDate(dateToAdd.getDate() + i);

      const existingDate = this.findDateInArray(dateToAdd, newWorkingTimeSchema.idEdit);
      if (existingDate) {
        this.someDateIsAlreadyTaken = true;

        let messageError = this._i18nService.instant('WORKING_TIME_SCHEMA.DATE_TAKEN');
        messageError = messageError.replace('{0}', existingDate.date.toLocaleDateString());
        this._showToastService.showToast(messageError, 'error');

        break;
      }
    }
  }

  save() {
    this._workingTimeSchemaService.updateCalendarBaseByUser(this.selectedUser.idUser, this.currentCalendarSelected.idWorkingTimeSchema).subscribe(response => {
      this.updateCustomCalendarByUser();
    });
  }

  updateCustomCalendarByUser() {
    this.convertToUTC();
    this._workingTimeSchemaService.updateCustomCalendar(this.datesCustomUserTable, this.selectedUser.idUser).subscribe(response => {
      this.getInfoUserSelected(this.selectedUser);
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
    });
  }

  convertToUTC(){
    this.datesCustomUserTable.forEach(date => {
      date.fromDate = DateUtil.converDateToStringNoAddOffset(date.fromDate);
      date.toDate = DateUtil.converDateToStringNoAddOffset(date.toDate);
      for (let i = 1; i <= 5; i++) {
        if(date[`fromTime${i}`])
          date[`fromTime${i}`] = date[`fromTime${i}`] ? DateUtil.converDateToStringNoAddOffset(date[`fromTime${i}`]) :null;
        if(date[`toTime${i}`])
          date[`toTime${i}`] = date[`toTime${i}`] ? DateUtil.converDateToStringNoAddOffset(date[`toTime${i}`]):null;
      }
    });
  }

  cancel() {
    const title = this._i18nService.instant('WORKING_TIME_SCHEMA.DISCARD_CHANGES');
    const message = this._i18nService.instant('WORKING_TIME_SCHEMA.DISCARD_CHANGES_MESSAGE');
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, button: 'WORKING_TIME_SCHEMA.DISCARD' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this.getInfoUserSelected(this.selectedUser);
      }
    });
  }

  findDateInArray(date: Date, idEdit: number): any {
    return this.datesCustomUserCalendarView.find(item => item.date.getTime() === date.getTime() && item.workingTime.idEdit !== idEdit);
  }

  getDaysBetween(startDate: Date, endDate: Date): number {
    const oneDay = 24 * 60 * 60 * 1000;
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const diffInMilliseconds = Math.abs(end - start);
    return Math.floor(diffInMilliseconds / oneDay) + 1;
  }
}